import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Share2, Copy, Download, CheckCircle2, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const PublishBundle = ({ post, onChange }) => {
  const [busy, setBusy] = useState(false);
  const [bundle, setBundle] = useState(null);

  const load = async () => { const { data } = await api.get(`/social/posts/${post.id}/bundle`); setBundle(data); return data; };
  const copyText = async () => { const b = bundle || await load(); await navigator.clipboard?.writeText(b.text || ""); toast.success("Légende + hashtags copiés"); };
  const share = async () => {
    setBusy(true);
    try {
      const b = bundle || await load();
      const files = [];
      for (const c of b.clips) { const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}${c.url}`, { credentials: "include" }); const blob = await r.blob(); files.push(new File([blob], c.name, { type: blob.type || "video/mp4" })); }
      if (navigator.share && (files.length === 0 || navigator.canShare?.({ files }))) {
        await navigator.share({ title: b.topic, text: b.text, ...(files.length ? { files } : {}) });
        toast.success("Partagé — collez la légende dans Instagram");
      } else {
        await navigator.clipboard?.writeText(b.text || "");
        window.location.href = `${API}/social/posts/${post.id}/bundle.zip`;
        toast.info("Partage direct indisponible ici : légende copiée + kit ZIP téléchargé");
      }
    } catch (e) { if (e?.name !== "AbortError") toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Partage impossible"); }
    finally { setBusy(false); }
  };
  const published = async () => { const { data } = await api.post(`/social/posts/${post.id}/mark-published`); onChange(data); toast.success("Marqué « Publié »"); };

  return (
    <div className="rounded-xl border border-emerald-200 bg-emerald-50/60 p-3 space-y-2" data-testid={`publish-bundle-${post.id}`}>
      <p className="text-[11px] font-bold tracking-wider uppercase text-emerald-700">Prêt à publier — kit en un geste</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-1.5">
        <Button onClick={share} disabled={busy} className="h-12 rounded-xl bg-emerald-600 hover:bg-emerald-700 sm:col-span-1" data-testid={`bundle-share-${post.id}`}>{busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Share2 className="w-4 h-4 mr-2" />}Partager vers Instagram</Button>
        <Button variant="outline" onClick={copyText} className="h-12 rounded-xl bg-white" data-testid={`bundle-copy-${post.id}`}><Copy className="w-4 h-4 mr-2" />Copier légende + hashtags</Button>
        <a href={`${API}/social/posts/${post.id}/bundle.zip`} className="h-12 rounded-xl bg-white border border-slate-200 text-sm font-medium inline-flex items-center justify-center hover:bg-slate-50" data-testid={`bundle-zip-${post.id}`}><Download className="w-4 h-4 mr-2" />Télécharger le kit (ZIP)</a>
      </div>
      <p className="text-[11px] text-slate-500">Le partage envoie vos clips réels + la légende vers l'application de votre choix (Instagram, TikTok…). Les visuels IA ne sont pas inclus : ils servent d'inspiration.</p>
      <button onClick={published} className="text-xs text-emerald-800 inline-flex items-center gap-1 font-medium" data-testid={`bundle-published-${post.id}`}><CheckCircle2 className="w-3.5 h-3.5" /> J'ai publié</button>
    </div>
  );
};
